<div class="row">
    <div class="col mt-4">
        @if (gridConfig) {
        <div [style.height.px]="gridHeight">
            <inavista-grid #returnOrderItemsGrid class="so-popup-grid"
                [config]="gridConfig"
                [actionIcons]="actionIcons"
                (hyperlinkClick)="showMasterItemCodePopup(itemFor($event.row))"
                (rowEditStart)="onRowEditStart($event)"
                (rowCommit)="onRowCommit($event)"
                (rowRevert)="onRowRevert()"
                (actionIconClick)="onActionIconClick($event)"
                (toolbarActionClick)="onToolbarActionClick($event)"
                (exportRequested)="onExportRequested()" />
        </div>
        }
    </div>
</div>

<!-- The open row's cells: each column's editor (CellEditorHost, @inavista/components controls). -->
@for (field of editFields; track field) {
    <ng-template #cellEditor let-row>
        <app-cell-editor [edit]="edits[field]" [field]="field" [rowData]="itemFor(row)" [registry]="openEditors" />
    </ng-template>
}

<!-- The open row's hidden columns: their editors, out of sight, as the old grid had them. -->
@if (hiddenEditRow) {
    <div class="d-none" aria-hidden="true">
        @for (field of hiddenEditFields; track field) {
            <app-cell-editor [edit]="edits[field]" [field]="field" [rowData]="hiddenEditRow" [registry]="openEditors" />
        }
    </div>
}

@if (showItemAdvancedSearchPopup) {
<app-items-advanced-search

    [category]="category"
    [warehouse]="warehouse"
    [technicianId]="technicianId"
    [module]="'ReturnOrder'"
    (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>
}
